var React = require('react');

function PencilInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.3889 0C11.6211 0 11.8438 0.0922425 12.008 0.256435L15.7436 3.99201C16.0855 4.33392 16.0855 4.88827 15.7436 5.23019L13.4093 7.5644C13.4092 7.56458 13.4095 7.56423 13.4093 7.5644C13.4092 7.56458 13.4085 7.56526 13.4083 7.56543L6.40463 14.5691C6.28241 14.6913 6.12674 14.7747 5.95725 14.8085L0 16L1.19145 10.0428C1.22535 9.87326 1.30866 9.71759 1.43088 9.59537L10.7698 0.256435C10.934 0.0922425 11.1567 0 11.3889 0ZM9.05417 4.44844L2.85651 10.6461L2.23216 13.7678L5.3539 13.1435L11.5516 6.94583L9.05417 4.44844ZM12.7897 5.70765L10.2923 3.21026L11.3889 2.1137L13.8863 4.6111L12.7897 5.70765Z","fill":"currentColor"}));
}

PencilInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = PencilInline;

PencilInline.default = PencilInline;
